import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../pages/layout/Layout";
import {
  viewAppointment,
  deleteAppointment,
} from "../../../states/actions/appointmentAction";
import Loading from "../loading/Loading";

const Appointments = () => {
  // dispatch
  const dispatch = useDispatch();

  const appointment = useSelector((state) => state.appointment);
  // use effect
  useEffect(() => {
    dispatch(viewAppointment());
  }, []);

  function handleRemoveFeedback(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!",
      )
    ) {
      dispatch(deleteAppointment(data.appointmentId));
    }
    setTimeout(function () {
      dispatch(viewAppointment());
    }, 500);
  }

  return (
    <Layout title={"Appointment"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">View Appointments</Typography>
        </Box>

        {appointment?.appointment ? (
          <Table
            data={appointment?.appointment}
            fields={AppointmentsColumns}
            numberOfRows={appointment?.appointment?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveFeedback}
          />
        ) : (
          <Loading />
        )}
      </Box>
    </Layout>
  );
};

export default Appointments;

export const AppointmentsColumns = [
  {
    accessorKey: "name", //access nested data with dot notation
    header: "Name",
  },
  {
    accessorKey: "email", //access nested data with dot notation
    header: "Email",
  },
  {
    accessorKey: "phone", //access nested data with dot notation
    header: "Phone no.",
  },
  {
    accessorKey: "consultationType", //access nested data with dot notation
    header: "Consultation Type",
  },
  {
    accessorKey: "practiceArea", //access nested data with dot notation
    header: "Practice Area",
  },
  {
    accessorKey: "date", //access nested data with dot notation
    header: "Date",
  },
  {
    accessorKey: "time", //access nested data with dot notation
    header: "Time",
  },
  {
    accessorKey: "message", //access nested data with dot notation
    header: "Message",
  },
];
